import imomoOperationalInput from './input/input.module';
import imomoOperationalJournal from './journal/journal.module';
import operationalComponent, {configStates} from './operational.component';
import optionsComponent from './options.component';

import bulletinComponent from './bulletin/bulletin.component';
import bulkDataDownloadComponent from './bulk-data-download/bulk-data-download.component';

export default angular.module('imomo.operational',
    [imomoOperationalInput, imomoOperationalJournal])
    .config(configStates)
    .component('imomoOperational', operationalComponent)
    .component('imomoOperationalOptions', optionsComponent)
    .component('imomoOperationalBulletin', bulletinComponent)
    .component('imomoOperationalBulkDataDownload', bulkDataDownloadComponent)
    .name;



/** WEBPACK FOOTER **
 ** ./app/operational/operational.module.ts
 **/